import { useQuery, UseQueryOptions } from "react-query";
import { API_URL, APIError, APIResponse, get } from "../api";
import { IntlOfferResult } from "../@types/intlFlightAggregator";

/**
 * Revalidates a single offer — call this immediately before showing a final
 * price or creating an order (offers expire and price/availability can
 * move). `enabled: false` by default; the checkout flow should trigger it
 * explicitly rather than firing on every render.
 */
function useGetInternationalOffer(
  offerId: string | undefined,
  options?: Omit<UseQueryOptions<APIResponse<IntlOfferResult>, APIError>, "queryKey" | "queryFn">
) {
  const query = useQuery<APIResponse<IntlOfferResult>, APIError>({
    queryKey: ["international-offer", offerId],
    queryFn: () =>
      get(`${API_URL}/aviation/international/v2/offers/${offerId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }),
    enabled: false,
    ...options,
  });

  return {
    offer: query.data?.data?.offer,
    refreshOffer: query.refetch,
    isRefreshingOffer: query.isFetching,
    offerError: query.error,
  };
}

export default useGetInternationalOffer;
